import React, { useEffect } from 'react';
import "./Academiccollaborations.css";
import Navbar from "../components/Navbar";

const Academiccollaborations = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="collab-container">
        <div className="collab-content">
          <p className="collab-content-para">Research & Innovation / Academic Collaborations</p>
          <h2>Academic Collaborations</h2>
          <p className="collab-subtitle1">Enabling the next generation of XR research and education.</p>
          <p>
            We work closely with educational institutions to explore how immersive
            technologies transform learning, cognition, and accessibility.
          </p>

          <div className="collab-grid">
            <div className="collab-row">
              <div className="collab-box">
                <h4>Immersive Learning Science</h4>
                <p>
                  Studying the effects of VR/AR on concept retention, engagement, and
                  skill acquisition in STEM, medicine, and engineering.
                </p>
                <p><strong>Ideal for:</strong> Educational institutions, ed-tech researchers</p>
              </div>
              <div className="collab-box">
                <h4>Human Perception in XR</h4>
                <p>
                  Conducting psychophysical studies on spatial orientation, motion sickness, and sensory
                  conflicts in immersive environments.
                </p>
                <p><strong>Ideal for:</strong> Multisensory integration, visual realism, XR ergonomics</p>
              </div>
            </div>

            <div className="collab-row">
              <div className="collab-box">
                <h4>Low-Cost XR for Tier 2/3 Institutions</h4>
                <p>
                  Designing mobile-first XR learning kits to support NEP-aligned education
                  in underserved regions.
                </p>
                <p><strong>Ideal for:</strong> Rural universities, ed-tech innovation programs</p>
              </div>

              <div className="collab-box">
                <h4>Natural Interfaces in XR</h4>
                <p>
                  Exploring eye, gesture, and voice-based controls for intuitive learning and accessible immersive experiences.
                </p>
                <p><strong>Ideal for:</strong> Linguistics, accessibility, and HCI researchers</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Academiccollaborations;
